import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBag2"><Path fillRule="evenodd" clipRule="evenodd" d="M16.5 7H19.4978C20.8785 7 21.9978 8.11929 21.9978 9.5V18.5C21.9978 19.8807 20.8785 21 19.4978 21H4.5C3.11929 21 2 19.8807 2 18.5V9.5C2 8.11929 3.11929 7 4.5 7H7.5V5C7.5 3.89543 8.39543 3 9.5 3H14.5C15.6046 3 16.5 3.89543 16.5 5V7ZM8.5 5C8.5 4.44772 8.94772 4 9.5 4H14.5C15.0523 4 15.5 4.44772 15.5 5V7H8.5V5ZM7.5 7H8.5V20.75H7.5V7ZM16.5 7V20.75H15.5V7H16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag2;
